// extracted by mini-css-extract-plugin
module.exports = {"NOTICE":"Notice_NOTICE__1fnZf","NOTICE__icon":"Notice_NOTICE__icon__osCLD"};